
import CheckboxField from '@/components/processing_steps/commons/fields/CheckboxField.vue'
import FormContainer from '@/components/processing_steps/commons/forms/FormContainer.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import SummaryItems from './forms/SummaryItems.vue'
import { ISummaryItem } from '@/types/processingSteps'

@Component({
  components: {
    FormContainer,
    CheckboxField,
    SummaryItems
  }
})
export default class CompletitionLayout extends Vue {
  @Prop() summaryItems!: ISummaryItem[]
  @Prop() stepTitle!: string
  @Prop() statusTitle!: string
  @Prop() statusExplanation!: string
  @Prop({ default: null }) statusIconClass!: string | null
  @Prop({ default: null }) summaryDescription!: string | null
  @Prop({ default: false }) noForm: boolean
}
